<template>
  <!-- 商品统计 -->
  <div class="saleAcount">
    <div class="tl_box">
      <div class="left">
        <div
          v-for="(item,index) in salesManage"
          :key="index"
          @click="switchSalesType(index)"
          :class="{active:index==nowSalesManage}"
        >{{item.value}}</div>
      </div>
      <!-- <div class="right">
        <div>日</div>
        <div>月</div>
        <div>年</div>
        <div>自定义</div>
      </div> -->
    </div>
    <div class="content_box">
      <!-- 商品统计 -->
      <goodsAcount v-if="nowSalesManage==0"/>
      <!-- 批次统计 -->
      <batchAcount v-if="nowSalesManage==1"/>
      <!-- 客户统计 -->
      <customerAcount v-if="nowSalesManage==2"/>
    </div>
  </div>
</template>
<script>
import goodsAcount from './goodsAcount'
import batchAcount from './batchAcount'
import customerAcount from './customerAcount'
export default {
  name: "saleAcount",
  components:{
    goodsAcount,
    batchAcount,
    customerAcount
  },
  data() {
    return {
      salesManage: [
        { index: 0, value: "商品统计" },
        { index: 1, value: "批次统计" },
        { index: 2, value: "客户统计" },
      ],
      nowSalesManage: 0,
    };
  },
  created() {},
  mounted() {},
  methods: {
    //销售统计切换筛选
    switchSalesType(sindex) {
      this.nowSalesManage = sindex;
    },
  },
};
</script>
<style lang="less" scoped>
//销售统计
.saleAcount {
  padding: 0.2rem;
  background: #fff;
  border-radius: 0.1rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  height: 100%;
  box-sizing: border-box;
  .tl_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.2rem;
    height: 0.4rem;
    .left {
      display: flex;
      div {
        height: 0.36rem;
        width: 1.1rem;
        text-align: center;
        line-height: 0.34rem;
        background: #fff;
        font-size: 0.18rem;
        border: 0.01rem solid #31b158;
        color: #31b158;
        border-radius: 0.04rem;
        margin-right: 0.1rem;
      }
      .active {
        background: #31b158;
        border: 0.01rem solid #31b158;
        color: #fff;
      }
    }
    .right {
      display: flex;
    }
  }
  .content_box {
    height: calc(100% - 0.4rem);
  }
}
</style>